import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetCommunicationMessagesQuery } from "../../../../store/admin/communicationSlice";
import EmptyTable from "../../../../components/Common/EmptyTable";
import { TableCompData } from "../../../../components";
import TableSkeletonLoader from "../../../../components/Common/TableSkeletonLoader";
import styled from "styled-components";
import { CommunicationMessagesHeader } from "../../../../utils/TableHeader";
import TablePagination from "../../../../components/Table/Pagination";

const DraftedMessages = ({ onEditDraft }) => {
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(1);
  const { data = {}, isLoading, isFetching } = useGetCommunicationMessagesQuery({
    page: pageNumber,
    status: "DRAFTED",
  });
  const { communication_group_messages = [], pagination = {} } = data;
  const handleViewDetail = (row) => {
    if (row?.id) navigate(`/super_admin/communication/messages/${row.id}`);
  };
  const handleEditDraft = (row) => {
    if (row?.id && onEditDraft) {
      onEditDraft(row.id);
    }
  };

  return (
    <Wrapper>
      <div>
        <TableCompData
          marginBottom={"2rem"}
          columns={CommunicationMessagesHeader(undefined, handleViewDetail)}
          data={communication_group_messages.map((item, index) => ({
            ...item,
            serialNumber:
              index + 1 + (pageNumber - 1) * (pagination.perPage || 20),
            onEdit: handleEditDraft,
          }))}
          progressPending={isFetching || isLoading}
          progressComponent={<TableSkeletonLoader rows={10} columns={10} />}
          message={
            !isLoading && !isFetching && communication_group_messages.length === 0 ? (
              <EmptyTable Message={"No draft messages found"} />
            ) : null
          }
        />
        {communication_group_messages.length > 0 && (
          <TablePagination handlePageChange={setPageNumber} {...pagination} />
        )}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 4px;
`;

export default DraftedMessages;
